const livePreviewHashKey = 'livePreviewHash'
const reloadHashKey = 'reloadHash'
const waitingSecondsBeforeReload = 2

function hasSamePayload({
	url,
	payload,
	keysToCheck,
}: {
	url: URL
	payload: Record<string, string>
	keysToCheck: string[]
}): boolean {
	if (!payload) {
		return false
	}
	return keysToCheck.every(
		(key) =>
			url.searchParams.get(key) !== null &&
			url.searchParams.get(key) === payload[key]
	)
}

function updateHash({
	url,
	hashKey,
	hash,
}: {
	url: URL
	hashKey: string
	hash: string | undefined
}) {
	if (hash && hash !== url.searchParams.get(hashKey)) {
		url.searchParams.set(hashKey, hash)
	}
}

function updatePayload({
	url,
	payload,
}: {
	url: URL
	payload: Record<string, string>
}) {
	if (payload !== undefined) {
		for (const [key, value] of Object.entries(payload)) {
			if (key !== 'windowType' && value !== undefined) {
				const paramKey = key === 'branch' ? 'csBranch' : key
				url.searchParams.set(paramKey, String(value))
			}
		}
	}
}

export function setSsrQueryParams({
	isSsr = true,
	livePreviewHash,
	payload,
}: {
	isSsr?: boolean
	livePreviewHash?: string
	payload?: Record<string, string>
}) {
	const isPayloadCall = Boolean(!livePreviewHash && payload)
	const url = new URL(window.location.href)
	const samePayload =
		!livePreviewHash &&
		payload &&
		hasSamePayload({
			url,
			payload,
			keysToCheck: ['contentTypeUid', 'entryUid'],
		})
	const reloadHash = Date.now()
	const lastReloadedHash = Number(url.searchParams.get(reloadHashKey))
	const isReloadHashTooOld =
		(reloadHash - lastReloadedHash) / 1000 > waitingSecondsBeforeReload
	const shouldReturn = isPayloadCall ? samePayload : !isReloadHashTooOld

	if (!isSsr || shouldReturn) {
		return
	}

	const lastLivePreviewHash = url.searchParams.get(livePreviewHashKey)

	if (isPayloadCall && payload && !samePayload) {
		updatePayload({ url, payload })
	}
	if (livePreviewHash && livePreviewHash !== lastLivePreviewHash) {
		updateHash({ url, hashKey: livePreviewHashKey, hash: livePreviewHash })
	}
	if (!isPayloadCall) {
		updateHash({ url, hashKey: reloadHashKey, hash: String(reloadHash) })
	}

	window.location.href = url.toString()
}
